import en from './en';
import tr from './tr';

export const translations = {
  en,
  tr,
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
];

export default translations;
